import React, { forwardRef, RefObject } from 'react';
import { Placement } from '@popperjs/core';
import { Popup, PopupTheme } from '../Popup/Popup';

type Props = React.HTMLAttributes<HTMLDivElement> & {
    readonly target: RefObject<HTMLElement>;
    readonly visible: boolean;
    readonly placement: Placement;
    readonly className?: string;
    readonly gap?: number;
    readonly displacement?: number;
    readonly onClose?: (visible: false) => void;
    readonly arrow?: boolean;
    readonly portal?: boolean;
};

export const Popover = forwardRef<HTMLDivElement, Props>((props, ref) => {
    return <Popup {...props} ref={ref} theme={PopupTheme.LIGHT} />;
});
